import React from 'react';

/**
 * Loading Overlay Component
 * Fullscreen loading animation with message
 * Used during async operations like quiz creation
 */
function LoadingOverlay({ message = 'Loading...', subMessage = null }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 max-w-md w-full mx-4 text-center">
        {/* Animated Spinner */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          {/* Outer rotating ring */}
          <div className="absolute inset-0 rounded-full border-4 border-gray-200"></div>

          {/* Inner rotating gradient ring */}
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#6B7A8F] border-r-[#6B7A8F] animate-spin"></div>

          {/* Center icon */}
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-[#6B7A8F] animate-pulse"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
        </div>

        {/* Main Message */}
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          {message}
        </h3>

        {/* Sub Message */}
        {subMessage && (
          <p className="text-gray-600 text-sm">
            {subMessage}
          </p>
        )}

        {/* Animated Dots */}
        <div className="flex justify-center gap-2 mt-6">
          <div className="w-2 h-2 bg-[#6B7A8F] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-[#6B7A8F] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-[#6B7A8F] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingOverlay;
